import type { ChatComposerLabels } from "@/components/chat/thread/ChatComposer";
import type { ChatRowLabels } from "@/components/chat/thread/ChatThreadRow";
import type { CommentTimestampLabels } from "@/domains/pm/utils/panelDates";
import { panelDateLocale } from "@/domains/pm/utils/panelDates";
import type { Language } from "@/lib/i18n/types";
import type { DocumentCommentsTranslations } from "@/lib/i18n/types/documents-sections/comments";

/** The shared thread row's strings, sourced from the documents namespace. */
export function rowLabels(t: DocumentCommentsTranslations): ChatRowLabels {
  return {
    reply: t.reply,
    edit: t.edit,
    edited: t.edited,
    save: t.save,
    cancel: t.cancel,
    delete: t.delete,
    confirmDelete: t.confirmDelete,
    confirmDeleteDescription: t.confirmDeleteDescription,
  };
}

/** Same for the root comment, whose delete removes the whole thread. */
export function rootRowLabels(t: DocumentCommentsTranslations): ChatRowLabels {
  return {
    ...rowLabels(t),
    delete: t.deleteThread,
    confirmDelete: t.confirmDeleteThread,
    confirmDeleteDescription: t.confirmDeleteThreadDescription,
  };
}

export function composerLabels(
  t: DocumentCommentsTranslations,
  placeholder: string
): ChatComposerLabels {
  return {
    placeholder,
    attach: t.attach,
    mention: t.mention,
    send: t.send,
    removeQuote: t.removeQuote,
  };
}

export function timestampLabels(
  t: DocumentCommentsTranslations,
  language: Language
): CommentTimestampLabels {
  return { justNow: t.justNow, yesterday: t.yesterday, locale: panelDateLocale(language) };
}
